import { USERS, CLIENTS, PROJECTS } from "@constants/routes/routes";

const SECURITY = [
  { route: USERS, name: "core:common.users" },
  { route: CLIENTS, name: "core:common.clients" },
  { route: PROJECTS, name: "core:common.projects" },
];

export default SECURITY;
